import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { formatNumber } from '../../utils';

interface FilterCountProps {
  count: number;
}

/**
 * Renders a count next to the filter name
 *
 * @param count - the number of search results matching the filter
 */
const FilterCount: React.FC<FilterCountProps> = ({ count }: FilterCountProps) => {
  return (
    <Box sx={{ pr: 4 }}>
      <Typography color="textSecondary" variant="subtitle2" data-testid="filter-count">
        {formatNumber(count)}
      </Typography>
    </Box>
  );
};

export default FilterCount;
